import {createContext, FC, ReactNode, useContext, useEffect, useState} from "react";
import {LocaleRU} from "./LocaleRU";
import {LocaleEN} from "./LocaleEN";

export type LocaleCode = 'ru' | 'en'

export interface LocaleKey {
    trailerVittaLucis: string
    trailerIkeNorris: string
    about: string
    soundtrack: string
    pressKit: string
    gameVittaLucis: string
    gameIkeNorris: string
    socialNetworksTitle: string
    socialNetworksDescription: string
    contactsTitle: string
    contactsDescription: string
    yandexMail: string
    otherTitle: string
    otherDescription: string
    yandexMusic: string
    vkMusic: string
    zvuk: string
    mtsMusic: string
    supportTitle: string
    supportDescription: string
    yandexTips: string
    inactiveTitle: string
    inactiveDescription: string
    dzen: string
    platform: string
    trashTitle: string
    trashDescription: string
    pikabu: string
}

export type LocaleDataType = {
    [key in LocaleCode]: LocaleKey
}

export interface LocaleContextType {
    setLocale: (locale: LocaleCode) => void
    localeText: (key: keyof LocaleKey) => string
}

const LocaleContext = createContext<LocaleContextType | undefined>(undefined)

interface LocaleProviderProps {
    children: ReactNode
}

export const LocaleData: LocaleDataType = {
    ru: LocaleRU,
    en: LocaleEN
}

export const LocaleProvider: FC<LocaleProviderProps> = ({children}) => {

    const [locale, setLocale] = useState<LocaleCode>(() => navigator.language.split('-')[0] === 'ru' ? 'ru' : 'en')

    useEffect(() => {document.documentElement.lang = locale}, [locale])

    const localeText = (key: keyof LocaleKey): string => LocaleData[locale][key]

    const value: LocaleContextType = {
        setLocale,
        localeText
    }

    return (
        <LocaleContext.Provider value={value}>
            {children}
        </LocaleContext.Provider>
    )

}

export const useLocale = (): LocaleContextType => {

    const context = useContext(LocaleContext)

    if (context === undefined) {
        throw new Error('LocaleProvider')
    }

    return context

}
